import AuthClientStore from "../components/auth/AuthClientStore";

export function authHeader(useOriginal = false): { Authorization?: string } {
    const tokenData = AuthClientStore.getAccessToken();
    if (tokenData) {
        return { Authorization: 'Bearer ' + tokenData };   
    }
    return {};
}
